import { render, staticRenderFns } from "./PresetsTab.vue?vue&type=template&id=11465150&scoped=true&"
import script from "./PresetsTab.vue?vue&type=script&lang=js&"
export * from "./PresetsTab.vue?vue&type=script&lang=js&"
import style0 from "./PresetsTab.vue?vue&type=style&index=0&id=11465150&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11465150",
  null
  
)

export default component.exports